// src/pages/currencies/Currencies.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import CurrenciesTable from "../../components/currencies/CurrenciesTable";

const Currencies = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            {/* data table Currencies */}
            <CurrenciesTable />
        </WrapperSection>
    );
};

export default Currencies;
